import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from 'merlin-library';
import { ClinicianApiEndPointConstants } from '../../utilitites/api-end-point-constants';

@Injectable({
    providedIn: 'root',
})
export class PatientProfilePrintDialogService {

    constructor(private apiService: ApiService, private http: HttpClient) { }

    getData(patientid) {
        return this.apiService.get(ClinicianApiEndPointConstants.patientListPatients+'/'+`${patientid}/print-profile`)
    }
}
